<template>
  <div class="container">
    <app-header title="用户服务协议"/>
    <div class="main">
      <div v-html="agreement"></div>
    </div>
  </div>
</template>

<script>

  import {getSysSetting} from '@/api/system/index.js'
  export default {
    name: 'agreement',
    data() {
      return {
        show: false,
        agreement: ''
      }
    },
    created(){
      this.getSysSetting();
    },
    methods: {
      getSysSetting(){
        getSysSetting({id: 1}).then(res=>{
          if (res.success) {
            this.agreement = res.data.agreement
          }
        })
      }
    }
  }
</script>

<style lang="less" scoped>
  .container {
    .main {
      flex-direction: column;
      justify-content: center;
      text-align: center;
      margin-top: 41px;
    }
  }
</style>



// WEBPACK FOOTER //
// src/views/login/agreement.vue